export default __webpack_public_path__ + "static/ui-footer-white-logo-81ea68705877ebc09ef0b54b1a9bb90e.svg";